export default __webpack_public_path__ + "a0f2f89ca7ee0bcd8d93ca417187123e.png";